import s from './footer.module.css';
import { PRIVACY_LINKS, TERMS_OF_USE_LINKS } from '../../constants/footerLinks';
import { retailerSettingsService } from '../../services';
import { store } from '../../store';

class FooterController {
  constructor() {
    const {
      language,
      page: { languageCode },
    } = store.getState();
    this.lang = language;
    this.s = s;
    this.retailer_name = retailerSettingsService.getName();
    this.product = 'R2';
    this.termsLink =
      language['returns.validate.footer.terms_of_use_link'] ||
      TERMS_OF_USE_LINKS[languageCode] ||
      TERMS_OF_USE_LINKS.en;
    this.privacyLink =
      language['returns.validate.footer.privacy_policy_link'] ||
      PRIVACY_LINKS[languageCode] ||
      PRIVACY_LINKS.en;
  }
}

export default FooterController;
